import Lang from 'lang.js'
import * as translationsCs from '@/../../lang/cs/js.json'
import * as translationsDe from '@/../../lang/de/js.json'
import * as translationsEn from '@/../../lang/en/js.json'
import * as translationsIt from '@/../../lang/it/js.json'

/**
 * Returns a translation message. Use `Lang.get()` method instead, this methods assumes the key exists.
 *
 * @param key {string} The key of the message.
 * @param locale {string} The locale of the message
 *
 * @return {string} The translation message for the given key.
 */
Lang.prototype._getMessage = function (key, locale) {
    key = key.replace(/"/g, '&quot;')
    locale = locale || this.getLocale()
    const fallbackLocale = this.getFallback()

    let message = _.get(this.messages, [locale, key])

    if (!message) {
        message = _.get(this.messages, [fallbackLocale, key], key)
    }

    return message
}

window.moment.locale(_.get(window, 'locale', 'cs'))

const lang = new Lang({
    messages: {
        cs: _.get(translationsCs, 'default', translationsCs),
        de: _.get(translationsDe, 'default', translationsDe),
        en: _.get(translationsEn, 'default', translationsEn),
        it: _.get(translationsIt, 'default', translationsIt)
    },
    locale: _.get(window, 'locale', 'cs'),
    fallback: 'en'
})

window.lang = lang
